import { AxiosError } from 'axios'

import { APP_CONFIG, CONFIGS_BY_ENVIRONMENT, STAGE } from 'src/config.app'
import { wbsBackendAxiosClient } from 'src/services/AxiosInterceptor'

export interface ScoringTestAPIResponse {
    fileUrl: string
    status?: string
    error?: string
}

export interface WbsSearchWorkflowIDsResponse {
    workflows: WbsWorkflowObject[]
    error?: string
}

export interface WbsWorkflowObject {
    id: string
    lastModifiedAt?: string
    lastModifiedBy?: string
}

interface WbsError extends Error {
    type: string
    message: string
}

export function handleWbsError(e: unknown) {
    const axiosError = e as AxiosError | undefined
    if (axiosError?.response?.data) {
        return axiosError?.response?.data as WbsError | undefined
    }
}

export interface WorkflowIdSearchParams {
    query: string
    offset: number
    limit: number
}

export async function callScoringTestAPI(workflowId: string, csvFileName: string, country: string) {
    const config = {
        headers: { 'Content-Type': 'application/json' },
    }
    const body = {
        workflowId: workflowId,
        csvFileName: csvFileName,
        country: country,
    }
    try {
        const { data, status } = await wbsBackendAxiosClient.post<{ outputFileUrl: string }>(
            APP_CONFIG.wbsConfig.wbsAPIUrl + '/scoringTesting',
            body,
            config
        )
        return {
            fileUrl: data.outputFileUrl,
            status: status.toString(),
        } as ScoringTestAPIResponse
    } catch (e: unknown) {
        const wbsError = handleWbsError(e)
        console.error(wbsError)
        return { fileUrl: '', error: wbsError?.message } as ScoringTestAPIResponse
    }
}

export async function searchWorkflowIds(searchParams: WorkflowIdSearchParams, stage?: STAGE) {
    const queryString = `limit=${searchParams.limit}&offset=${
        searchParams.offset
    }&query=${encodeURIComponent(searchParams.query)}`
    try {
        const { data } = await wbsBackendAxiosClient.get<{ items: WbsWorkflowObject[] }>(
            `${
                stage
                    ? CONFIGS_BY_ENVIRONMENT[stage].wbsConfig.wbsAPIUrl
                    : APP_CONFIG.wbsConfig.wbsAPIUrl
            }/workflows?${queryString}`
        )
        const workflows: WbsWorkflowObject[] = Array.from(data['items'])
        return { workflows: workflows } as WbsSearchWorkflowIDsResponse
    } catch (e: unknown) {
        const wbsError = handleWbsError(e)
        console.error(wbsError)
        return {
            workflows: [],
            error: 'Something went wrong while searching for workflow IDs',
        } as WbsSearchWorkflowIDsResponse
    }
}
